import React from "react";

import MaterialTable from 'material-table';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import List from "@material-ui/icons/List";
import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { convertToDisplayDate } from "../../assets/helpers/dataHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';
import { SUPPORT_EMAIL } from "../../api-config";


const tableStyle = require('../../assets/style/tableStyle.json');
tableStyle['maxBodyHeight'] = '35vh'
const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  exampleTrack: {
    color: 'red'
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle
};

class BatchMessageList extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')

    this.state = {
      userId: userId,
      batchMessageList: [{ messageType: 'loading...', messageSubject: 'loading...', messageText: 'loading...',
        queueDatetime: 'loading...', sentDatetime: 'loading...', status: 'loading...', file: 'loading...' }],
      messageDetailsDialogueOpen: false,
      detailsMessageTextFull: '',
      detailsMessageSubject: '',
      detailsMessageStatus: '',
      detailsMessageSentDatetime: '',
    };
  }
  componentDidMount() {
    this._isMounted = true;
    this.getBatchMessageStatus()
    // this.getFeeFreqOptions()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }



  getBatchMessageStatus() {
    axios.get(`${API_ROOT}/batchMessageStatus/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setBatchMessageStatus(res.data));
  }

  setBatchMessageStatus(res) {
    if (this._isMounted && !res.error) {
      const messageLengthCutoff = 50
      this.setState({
        batchMessageList: res.map((prop, key) => {
          var messageText = prop.messageText
          if (messageText.length > messageLengthCutoff) {
            const messageTextFull = messageText
            messageText = (
              <div> {messageText.substring(0, messageLengthCutoff)} ...<Button simple
                                                                               size="sm"
                                                                               color="cirrusBlue"
                                                                                onClick={this.handleMessageDetailsDialogOpen.bind(this,messageTextFull, prop.messageSubject, prop.status, prop.sentDatetime)}
                                                                               style={{cursor: "pointer"}}>
                                                                          view
                                                                        </Button>
              </div>
            )
          }

          return {
            messageType: prop.messageType,
            messageSubject: prop.messageSubject,
            messageText: messageText,
            queueDatetime: convertToDisplayDate(prop.queueDatetime),
            sentDatetime: convertToDisplayDate(prop.sentDatetime),
            status: prop.messageStatus,
            file: (
              <div>
                {/* use this button to add a like kind of action */}
                <Button
                  justIcon
                  round
                  simple
                  onClick={this.getSentToFile.bind(this, prop.user_id, prop.messageSendToFile)}
                  className="like"
                  color="cirrusBlue"
                  id={"viewSentToFile" + prop.file}
                >
                  <List/>
                </Button>{" "}
              </div>
            )
          };
        })
      });
    }
  }

  getSentToFile(userId, filename) {
    axios.get(`${API_ROOT}/batchMessageSendToList/?userId=`+userId + `&filename=` + filename, {headers: getApiHeaders()})
      .then(res => this.viewSentToFile(res.data));
  }

  viewSentToFile(res) {
    if (res['signedUrl']) {
      const link = document.createElement('a');
      link.href = res['signedUrl'];
      link.target = "_blank"
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      var error;
      if (res['error']) {
        error = res['error']
      } else {
        error = 'An unknown error occurred. Please try again. If the issues persists, please email ' + SUPPORT_EMAIL + '.'
      }
      alert(error)
    }
  }

  handleMessageDetailsDialogOpen(messageTextFull, messageSubject, status, sentDatetime) {
    this.setState({
      messageDetailsDialogueOpen: true,
      detailsMessageTextFull: messageTextFull,
      detailsMessageSubject: messageSubject,
      detailsMessageStatus: status,
      detailsMessageSentDatetime: convertToDisplayDate(sentDatetime)
    });

  };

  handleMessageDetailsDialogClose() {
    this.setState({
      messageDetailsDialogueOpen: false
    });
  };


  render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', align: 'center', height: '100%'}}>
        <Dialog
          classes={{ paper: classes.dialogPaper }}
          open={this.state.messageDetailsDialogueOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth='md'
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">Batch message details</DialogTitle>
          <DialogContent>
            <GridContainer>
              <GridItem xs={12} sm={12} md={2} lg={2}>
                status
              </GridItem>
              <GridItem xs={12} sm={22} md={10} lg={10}>
                {this.state.detailsMessageStatus}
              </GridItem>
              <GridItem xs={12} sm={12} md={2} lg={2}>
                sent date
              </GridItem>
              <GridItem xs={12} sm={22} md={10} lg={10}>
                {this.state.detailsMessageSentDatetime}
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <hr />
              </GridItem>
              <GridItem xs={12} sm={12} md={2} lg={2}>
                subject
              </GridItem>
              <GridItem xs={12} sm={22} md={10} lg={10}>
                {this.state.detailsMessageSubject}
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <hr />
              </GridItem>
              <GridItem xs={12} sm={12} md={2} lg={2}>
                message
              </GridItem>
              <GridItem xs={12} sm={22} md={10} lg={10}>
                {this.state.detailsMessageTextFull}
              </GridItem>

            </GridContainer>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleMessageDetailsDialogClose.bind(this)} color="cirrusBlue">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <GridContainer>
          <MaterialTable
            title=''
            columns={[
              { title: 'type', field: 'messageType'},
              { title: 'subject', field: 'messageSubject' },
              { title: 'message', field: 'messageText' },
              { title: 'status', field: 'status' },
              { title: 'queued date', field: 'queueDatetime' },
              { title: 'sent date', field: 'sentDatetime' },
              { title: 'sent to', field: 'file' },
            ]}
            data={this.state.batchMessageList}

            options={tableStyle}
          />

        </GridContainer>
      </div>

    );
  }
}

export default withStyles(style)(BatchMessageList);
